import { useQuery } from '@tanstack/react-query';

import { volatilityService } from '@services/volatilityService';

/**
 * Hook that manages volatility updates for all assets using React Query.
 * Fetches volatility data every 1 minute and stores it in the volatility service singleton.
 * Individual asset failures are handled gracefully with automatic retries.
 */
export const useVolatilityUpdate = () => {
  return useQuery({
    queryKey: ['volatility-all-assets'],
    queryFn: () => volatilityService.fetchAllVolatilities(),
    staleTime: 60 * 1000, // 1 minute
    refetchInterval: 60 * 1000, // Refetch every 1 minute
    refetchOnMount: 'always', // Always refetch on mount to sync with service singleton
    gcTime: 0, // Don't persist this query - service is source of truth
    retry: (failureCount, error) => {
      // Retry failed individual asset fetches up to 3 times
      console.warn('Volatility fetch failed, retrying...', error);
      return failureCount < 3;
    },
    retryDelay: attemptIndex => {
      // Exponential backoff: 2s, 4s, 8s
      return Math.min(1000 * 2 ** attemptIndex, 8000);
    },
  });
};
